export default "__VITE_ASSET__CVfbqOA4__"